var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hamburger-menu_svg__cls-1",
    d: "M24 4H0V0h24Zm0 4H0v4h24Zm0 8H0v4h24Z",
    "data-name": "Layer 1"
  }))));
};

export { SvgHamburgerMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgPCEtLSAuY2xzLTEgewogICAgICAgIGZpbGw6ICMwMTAxMDE7CiAgICAgIH0gLS0+CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+bWVudS0xODwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cGF0aCBpZD0ibWVudS0xIiBjbGFzcz0iY2xzLTEiIGQ9Ik0yNCw0SDBWMEgyNFptMCw0SDB2NEgyNFptMCw4SDB2NEgyNFoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";